// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-page {
    min-width: 600px;
}

.yellow {
    /* not themable */
    color: #D67F3C;
}

.pipelines-page {
    height: 800px;
}
`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Page/examples/Page.Example.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".sample-page {\r\n    min-width: 600px;\r\n}\r\n\r\n.yellow {\r\n    /* not themable */\r\n    color: #D67F3C;\r\n}\r\n\r\n.pipelines-page {\r\n    height: 800px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
